import * as requestFromServer from './inscripcionCrud';
import { inscripcionSlice, callTypes } from './inscripcionSlice';
import { llamadoSlice, callTypes as callTypesLlamado } from './llamadoSlice';

const { actions } = inscripcionSlice;
const { actions: actionsLlamado } = llamadoSlice;

export const fetchInscripciones = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.list }));
    return requestFromServer
        .getInscripcionesByUser(queryParams)
        .then(response => {
            const inscripciones = response.data;
            dispatch(actions.inscripcionesFetched({ inscripciones }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchDescartarInscripcion = inscripcionId => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .deleteInscripcion(inscripcionId)
        .then(response => {
            //const inscripciones = response.data;
            dispatch(actions.inscripcionDeleted({ inscripcionId }));
            dispatch(fetchInscripciones());
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchLlamados = queryParams => dispatch => {
    dispatch(actionsLlamado.starCall({ callType: callTypesLlamado.list }));
    return requestFromServer
        .getLlamados(queryParams)
        .then(response => {
            const llamados = response.data;
            dispatch(actionsLlamado.llamadosFetched({ llamados }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actionsLlamado.catchError({ error, callType: callTypesLlamado.list }));
        });
};